var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h2',{staticClass:"font-weight-bold text-uppercase text-center mt-6"},[_vm._v(" "+_vm._s(_vm.msg)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }